/* Tienda Flashs - comprobador "¿me vale en mi baño?" (tf-lp-check). Sin dependencias. */
(function () {
  function init(sec) {
    if (sec.__tfCheck) return;
    sec.__tfCheck = true;
    var items = [].slice.call(sec.querySelectorAll('[data-q]'));
    var pending = sec.querySelector('[data-pending]');
    var ok = sec.querySelector('[data-ok]');
    var ko = sec.querySelector('[data-ko]');

    function update() {
      var answered = 0, blocked = false;
      items.forEach(function (it) {
        var v = it.getAttribute('data-answer');
        var note = it.querySelector('[data-no]');
        if (v) answered++;
        if (note) note.hidden = v !== 'no' || !note.textContent.trim();
        if (v === 'no' && it.getAttribute('data-blocking') === '1') blocked = true;
      });
      var done = answered === items.length;
      pending.hidden = done || blocked;
      ok.hidden = !done || blocked;
      ko.hidden = !blocked;
    }

    items.forEach(function (it) {
      it.querySelectorAll('button[data-v]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          it.setAttribute('data-answer', btn.getAttribute('data-v'));
          it.querySelectorAll('button[data-v]').forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          update();
        });
      });
    });
    update();
  }

  function run(scope) {
    (scope || document).querySelectorAll('[data-tf-check]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
